import type { ReactNode } from "react";
import { cn } from "@/components/libs/cn";

type WithPhoneFrameProps = {
  children: ReactNode;
  className?: string;
};

export function WithPhoneFrame({ children, className }: WithPhoneFrameProps) {
  return (
    <div
      className={cn("relative inline-block z-[2]", className)}
      style={{ pointerEvents: "none" }}
    >
      <div
        className="absolute overflow-hidden"
        style={{
          left: "3.4%",
          right: "3.4%",
          top: "1.32%",
          bottom: "1.32%",
          borderRadius: "30px",
          pointerEvents: "none",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        {children}
      </div>

      <div className="relative top-0 z-[2] w-full leading-[0]">
        <svg
          width="100%"
          viewBox="0 0 415 843"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mt-[4px]"
        >
          <g clipPath="url(#clip0_2201_70)">
            <path
              d="M415 343C415 344.105 414.105 345 413 345L410 345L410 246L413 246C414.105 246 415 246.895 415 248L415 343Z"
              fill="#F0ECE3"
            />
            <path
              opacity="0.76"
              d="M415 343C415 344.105 414.105 345 413 345L410 345L410 246L413 246C414.105 246 415 246.895 415 248L415 343Z"
              fill="url(#paint0_linear_2201_70)"
            />
            <path
              d="M415 343C415 344.105 414.105 345 413 345L410 345L410 246L413 246C414.105 246 415 246.895 415 248L415 343Z"
              fill="url(#paint1_linear_2201_70)"
            />
            <path
              opacity="0.48"
              d="M415 343C415 344.105 414.105 345 413 345L410 345L410 246L413 246C414.105 246 415 246.895 415 248L415 343Z"
              fill="url(#paint2_linear_2201_70)"
            />
            <g filter="url(#filter0_f_2201_70)">
              <path
                d="M414 266.5C414 266.776 413.776 267 413.5 267C413.224 267 413 266.776 413 266.5L413 248L414 248L414 266.5Z"
                fill="white"
              />
            </g>
            <g filter="url(#filter1_f_2201_70)">
              <path
                d="M414 339L413 339L413 248.5C413 248.224 413.224 248 413.5 248C413.776 248 414 248.224 414 248.5L414 339Z"
                fill="white"
                fillOpacity="0.8"
              />
            </g>
            <g filter="url(#filter2_f_2201_70)">
              <path
                d="M415 341L414 341L414 246.5C414 246.224 414.224 246 414.5 246C414.776 246 415 246.224 415 246.5L415 341Z"
                fill="#61605D"
              />
            </g>
          </g>
          <g clipPath="url(#clip1_2201_70)">
            <path
              d="M0 151C0 149.895 0.895431 149 2 149H5V180H2C0.89543 180 0 179.105 0 178V151Z"
              fill="#F0ECE3"
            />
            <path
              opacity="0.76"
              d="M0 151C0 149.895 0.895431 149 2 149H5V180H2C0.89543 180 0 179.105 0 178V151Z"
              fill="url(#paint3_linear_2201_70)"
            />
            <path
              d="M0 151C0 149.895 0.895431 149 2 149H5V180H2C0.89543 180 0 179.105 0 178V151Z"
              fill="url(#paint4_linear_2201_70)"
            />
            <path
              opacity="0.48"
              d="M0 151C0 149.895 0.895431 149 2 149H5V180H2C0.89543 180 0 179.105 0 178V151Z"
              fill="url(#paint5_linear_2201_70)"
            />
            <g filter="url(#filter3_f_2201_70)">
              <path
                d="M1 150.5C1 150.224 1.22386 150 1.5 150C1.77614 150 2 150.224 2 150.5V156H1V150.5Z"
                fill="white"
              />
            </g>
            <g filter="url(#filter4_f_2201_70)">
              <path
                d="M1 152H2V177.5C2 177.776 1.77614 178 1.5 178C1.22386 178 1 177.776 1 177.5V152Z"
                fill="white"
                fillOpacity="0.8"
              />
            </g>
            <g filter="url(#filter5_f_2201_70)">
              <path
                d="M0 148H1V181.5C1 181.776 0.776142 182 0.5 182C0.223858 182 0 181.776 0 181.5V148Z"
                fill="#61605D"
              />
            </g>
          </g>
          <g clipPath="url(#clip2_2201_70)">
            <path
              d="M0 211C0 209.895 0.895431 209 2 209H5V265H2C0.89543 265 0 264.105 0 263V211Z"
              fill="#F0ECE3"
            />
            <path
              opacity="0.76"
              d="M0 211C0 209.895 0.895431 209 2 209H5V265H2C0.89543 265 0 264.105 0 263V211Z"
              fill="url(#paint6_linear_2201_70)"
            />
            <path
              d="M0 211C0 209.895 0.895431 209 2 209H5V265H2C0.89543 265 0 264.105 0 263V211Z"
              fill="url(#paint7_linear_2201_70)"
            />
            <path
              opacity="0.48"
              d="M0 211C0 209.895 0.895431 209 2 209H5V265H2C0.89543 265 0 264.105 0 263V211Z"
              fill="url(#paint8_linear_2201_70)"
            />
            <g filter="url(#filter6_f_2201_70)">
              <path
                d="M1 211.5C1 211.224 1.22386 211 1.5 211C1.77614 211 2 211.224 2 211.5V222H1V211.5Z"
                fill="white"
              />
            </g>
            <g filter="url(#filter7_f_2201_70)">
              <path
                d="M1 212H2V263.5C2 263.776 1.77614 264 1.5 264C1.22386 264 1 263.776 1 263.5V212Z"
                fill="white"
                fillOpacity="0.8"
              />
            </g>
            <g filter="url(#filter8_f_2201_70)">
              <path
                d="M0 209H1V266.5C1 266.776 0.776142 267 0.5 267C0.223858 267 0 266.776 0 266.5V209Z"
                fill="#61605D"
              />
            </g>
          </g>
          <g clipPath="url(#clip3_2201_70)">
            <path
              d="M0 284C0 282.895 0.895431 282 2 282H5V338H2C0.89543 338 0 337.105 0 336V284Z"
              fill="#F0ECE3"
            />
            <path
              opacity="0.76"
              d="M0 284C0 282.895 0.895431 282 2 282H5V338H2C0.89543 338 0 337.105 0 336V284Z"
              fill="url(#paint9_linear_2201_70)"
            />
            <path
              d="M0 284C0 282.895 0.895431 282 2 282H5V338H2C0.89543 338 0 337.105 0 336V284Z"
              fill="url(#paint10_linear_2201_70)"
            />
            <path
              opacity="0.48"
              d="M0 284C0 282.895 0.895431 282 2 282H5V338H2C0.89543 338 0 337.105 0 336V284Z"
              fill="url(#paint11_linear_2201_70)"
            />
            <g filter="url(#filter9_f_2201_70)">
              <path
                d="M1 284.5C1 284.224 1.22386 284 1.5 284C1.77614 284 2 284.224 2 284.5V295H1V284.5Z"
                fill="white"
              />
            </g>
            <g filter="url(#filter10_f_2201_70)">
              <path
                d="M1 285H2V336.5C2 336.776 1.77614 337 1.5 337C1.22386 337 1 336.776 1 336.5V285Z"
                fill="white"
                fillOpacity="0.8"
              />
            </g>
            <g filter="url(#filter11_f_2201_70)">
              <path
                d="M0 282H1V339.5C1 339.776 0.776142 340 0.5 340C0.223858 340 0 339.776 0 339.5V282Z"
                fill="#61605D"
              />
            </g>
          </g>
          <g clipPath="url(#clip4_2201_70)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M53 0C25.3858 0 3 22.3858 3 50V793C3 820.614 25.3858 843 53 843H362C389.614 843 412 820.614 412 793V50C412 22.3858 389.614 0 362 0H53ZM65 12C37.3858 12 15 34.3858 15 62V781C15 808.614 37.3858 831 65 831H350C377.614 831 400 808.614 400 781V62C400 34.3858 377.614 12 350 12H65Z"
              fill="#E7E3BF"
            />
            <g filter="url(#filter12_f_2201_70)">
              <rect
                x="4.5"
                y="1.5"
                width="406"
                height="840"
                rx="60.5"
                stroke="#C3C3C3"
                strokeWidth="3"
              />
            </g>
            <g filter="url(#filter13_f_2201_70)">
              <rect
                x="3.5"
                y="0.5"
                width="408"
                height="842"
                rx="61.5"
                stroke="#524B40"
              />
            </g>
            <g filter="url(#filter14_f_2201_70)">
              <rect
                x="8.5"
                y="5.5"
                width="398"
                height="831"
                rx="61.5"
                stroke="white"
              />
            </g>
            <rect
              x="8.8"
              y="5.8"
              width="397.4"
              height="830.4"
              rx="62.2"
              stroke="white"
              strokeWidth="0.4"
            />
            <rect
              x="321"
              width="6"
              height="4"
              fill="url(#paint12_linear_2201_70)"
            />
            <rect
              x="3"
              y="87"
              width="6"
              height="4"
              transform="rotate(-90 3 87)"
              fill="url(#paint13_linear_2201_70)"
            />
            <rect
              x="3"
              y="756"
              width="4"
              height="6"
              fill="url(#paint14_linear_2201_70)"
            />
            <rect
              x="66"
              y="839"
              width="5"
              height="4"
              fill="url(#paint15_linear_2201_70)"
            />
            <rect
              x="408"
              y="756"
              width="4"
              height="6"
              fill="url(#paint16_linear_2201_70)"
            />
          </g>
          <g clipPath="url(#clip5_2201_70)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M57 4C29.3858 4 7 26.3858 7 54V789C7 816.614 29.3858 839 57 839H358C385.614 839 408 816.614 408 789V54C408 26.3858 385.614 4 358 4H57ZM65 12C37.3858 12 15 34.3858 15 62V781C15 808.614 37.3858 831 65 831H350C377.614 831 400 808.614 400 781V62C400 34.3858 377.614 12 350 12H65Z"
              fill="#030303"
            />
          </g>
          <rect
            x="152"
            y="24"
            width="110"
            height="31"
            rx="15.5"
            fill="#030303"
          />
          <circle cx="245.62" cy="39.6202" r="9.62021" fill="#0E0B0F" />
          <circle cx="245.62" cy="39.6202" r="5.34456" fill="#161424" />
          <circle cx="245.62" cy="39.6202" r="3.20674" fill="#0F0F2A" />
          <circle cx="245.62" cy="38.5512" r="1.06891" fill="#393752" />
          <path
            opacity="0.35"
            d="M340 33.5275H357C358.918 33.5275 360.472 35.0822 360.472 37V42C360.472 43.9178 358.918 45.4725 357 45.4725H340C338.082 45.4725 336.528 43.9178 336.528 42V37C336.528 35.0822 338.082 33.5275 340 33.5275Z"
            stroke="#0D0D0E"
            strokeWidth="1.05509"
          />
          <path
            opacity="0.4"
            d="M362 38V42.2203C362.849 41.8629 363.401 41.0314 363.401 40.1102C363.401 39.1889 362.849 38.3574 362 38"
            fill="#0D0D0E"
          />
          <path
            d="M338 37C338 35.8954 338.895 35 340 35H357C358.105 35 359 35.8954 359 37V42C359 43.1046 358.105 44 357 44H340C338.895 44 338 43.1046 338 42V37Z"
            fill="#0D0D0E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M321.5 35.5875C323.967 35.5876 326.339 36.5551 328.127 38.2898C328.261 38.4237 328.477 38.4221 328.609 38.286L329.896 36.9605C329.963 36.8915 330.001 36.798 330 36.7008C329.999 36.6035 329.961 36.5105 329.893 36.4423C325.201 31.8526 317.799 31.8526 313.107 36.4423C313.039 36.5105 313.001 36.6034 313 36.7007C312.999 36.7979 313.037 36.8914 313.104 36.9605L314.391 38.286C314.523 38.4223 314.739 38.424 314.873 38.2898C316.661 36.5549 319.034 35.5875 321.5 35.5875ZM321.536 39.6724C322.891 39.6723 324.198 40.1864 325.203 41.115C325.338 41.2467 325.552 41.2439 325.685 41.1085L326.97 39.7829C327.038 39.7134 327.075 39.6191 327.074 39.5211C327.073 39.4231 327.034 39.3295 326.965 39.2614C323.906 36.3568 319.169 36.3568 316.109 39.2614C316.04 39.3295 316.001 39.4231 316 39.5212C315.999 39.6192 316.037 39.7135 316.105 39.7829L317.39 41.1085C317.522 41.2439 317.736 41.2467 317.872 41.115C318.876 40.1871 320.182 39.6729 321.536 39.6724ZM324.15 42.3427C324.152 42.441 324.114 42.5357 324.045 42.6046L321.822 44.8948C321.756 44.9621 321.668 45 321.575 45C321.482 45 321.393 44.9621 321.328 44.8948L319.105 42.6046C319.036 42.5357 318.998 42.4409 319 42.3426C319.002 42.2443 319.044 42.1512 319.115 42.0853C320.535 40.8595 322.615 40.8595 324.035 42.0853C324.106 42.1513 324.148 42.2444 324.15 42.3427Z"
            fill="#0D0D0E"
          />
          <path
            d="M298 36C298 35.4477 298.448 35 299 35H300C300.552 35 301 35.4477 301 36V44C301 44.5523 300.552 45 300 45H299C298.448 45 298 44.5523 298 44V36Z"
            fill="#0D0D0E"
          />
          <path
            d="M303 34C303 33.4477 303.448 33 304 33H305C305.552 33 306 33.4477 306 34V44C306 44.5523 305.552 45 305 45H304C303.448 45 303 44.5523 303 44V34Z"
            fill="#0D0D0E"
          />
          <path
            d="M293 39.5C293 38.9477 293.448 38.5 294 38.5H295C295.552 38.5 296 38.9477 296 39.5V44C296 44.5523 295.552 45 295 45H294C293.448 45 293 44.5523 293 44V39.5Z"
            fill="#0D0D0E"
          />
          <path
            d="M288 42C288 41.4477 288.448 41 289 41H290C290.552 41 291 41.4477 291 42V44C291 44.5523 290.552 45 290 45H289C288.448 45 288 44.5523 288 44V42Z"
            fill="#0D0D0E"
          />
          <path
            d="M76.9666 33.7231C79.5232 33.7231 81.7479 35.541 81.7479 39.8574V39.874C81.7479 43.9082 79.93 46.2988 76.9168 46.2988C74.7171 46.2988 73.0735 44.9956 72.6917 43.1611L72.6751 43.0698H74.7835L74.8084 43.1528C75.1238 43.9912 75.8626 44.5391 76.9168 44.5391C78.8177 44.5391 79.6229 42.6797 79.7142 40.3887C79.7142 40.2974 79.7225 40.2061 79.7225 40.1147H79.5564C79.1165 41.061 78.0706 41.8994 76.4271 41.8994C74.1277 41.8994 72.5174 40.2227 72.5174 37.9482V37.9316C72.5174 35.4995 74.3685 33.7231 76.9666 33.7231ZM76.9583 40.2559C78.3113 40.2559 79.3489 39.2764 79.3489 37.9233V37.9067C79.3489 36.5371 78.3113 35.4663 76.9832 35.4663C75.6634 35.4663 74.6092 36.5205 74.6092 37.8569V37.8735C74.6092 39.2598 75.597 40.2559 76.9583 40.2559ZM84.7164 38.2388C83.961 38.2388 83.3966 37.6577 83.3966 36.9272C83.3966 36.1885 83.961 35.6157 84.7164 35.6157C85.4801 35.6157 86.0362 36.1885 86.0362 36.9272C86.0362 37.6577 85.4801 38.2388 84.7164 38.2388ZM84.7164 44.3979C83.961 44.3979 83.3966 43.8252 83.3966 43.0864C83.3966 42.3477 83.961 41.7749 84.7164 41.7749C85.4801 41.7749 86.0362 42.3477 86.0362 43.0864C86.0362 43.8252 85.4801 44.3979 84.7164 44.3979ZM93.4955 46V43.7007H87.6352V41.9492C89.1874 39.2515 90.8891 36.4956 92.516 34.022H95.5458V41.9326H97.1562V43.7007H95.5458V46H93.4955ZM89.6273 41.9824H93.5287V35.7319H93.4042C92.1757 37.6079 90.7895 39.8242 89.6273 41.8579V41.9824ZM101.32 46V36.1304H101.179L98.1989 38.2388V36.2217L101.328 34.022H103.462V46H101.32Z"
            fill="#0D0D0E"
          />
          <defs>
            <filter
              id="filter0_f_2201_70"
              x="412"
              y="247"
              width="3"
              height="21"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter1_f_2201_70"
              x="412"
              y="247"
              width="3"
              height="93"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter2_f_2201_70"
              x="412"
              y="244"
              width="5"
              height="99"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter3_f_2201_70"
              x="0"
              y="149"
              width="3"
              height="8"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter4_f_2201_70"
              x="0"
              y="151"
              width="3"
              height="28"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter5_f_2201_70"
              x="-2"
              y="146"
              width="5"
              height="38"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter6_f_2201_70"
              x="0"
              y="210"
              width="3"
              height="13"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter7_f_2201_70"
              x="0"
              y="211"
              width="3"
              height="54"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter8_f_2201_70"
              x="-2"
              y="207"
              width="5"
              height="62"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter9_f_2201_70"
              x="0"
              y="283"
              width="3"
              height="13"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter10_f_2201_70"
              x="0"
              y="284"
              width="3"
              height="54"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.5"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter11_f_2201_70"
              x="-2"
              y="280"
              width="5"
              height="62"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter12_f_2201_70"
              x="-1"
              y="-4"
              width="417"
              height="851"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="2"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter13_f_2201_70"
              x="1"
              y="-2"
              width="413"
              height="847"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <filter
              id="filter14_f_2201_70"
              x="6"
              y="3"
              width="403"
              height="836"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="1"
                result="effect1_foregroundBlur_2201_70"
              />
            </filter>
            <linearGradient
              id="paint0_linear_2201_70"
              x1="412.5"
              y1="345"
              x2="412.5"
              y2="340.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_2201_70"
              x1="410"
              y1="345"
              x2="413.5"
              y2="345"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopColor="#AEAEAE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_2201_70"
              x1="412.5"
              y1="250.5"
              x2="412.5"
              y2="246"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_2201_70"
              x1="2.5"
              y1="149"
              x2="2.5"
              y2="152"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_2201_70"
              x1="5"
              y1="149"
              x2="1.5"
              y2="149"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopColor="#AEAEAE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_2201_70"
              x1="2.5"
              y1="174.697"
              x2="2.5"
              y2="180"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_2201_70"
              x1="2.5"
              y1="209"
              x2="2.5"
              y2="213"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_2201_70"
              x1="5"
              y1="209"
              x2="1.5"
              y2="209"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopColor="#AEAEAE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_2201_70"
              x1="2.5"
              y1="261"
              x2="2.5"
              y2="265"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_2201_70"
              x1="2.5"
              y1="282"
              x2="2.5"
              y2="286"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_2201_70"
              x1="5"
              y1="282"
              x2="1.5"
              y2="282"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopColor="#AEAEAE" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_2201_70"
              x1="2.5"
              y1="334"
              x2="2.5"
              y2="338"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0" />
              <stop offset="1" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_2201_70"
              x1="324"
              y1="0"
              x2="324"
              y2="4"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#817E73" />
              <stop offset="1" stopColor="#C3BEAC" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_2201_70"
              x1="6"
              y1="87"
              x2="6"
              y2="91"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#817E73" />
              <stop offset="1" stopColor="#C3BEAC" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_2201_70"
              x1="3"
              y1="759"
              x2="7"
              y2="759"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#817E73" />
              <stop offset="1" stopColor="#C3BEAC" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_2201_70"
              x1="68.5"
              y1="843"
              x2="68.5"
              y2="839"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#817E73" />
              <stop offset="1" stopColor="#C3BEAC" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_2201_70"
              x1="412"
              y1="759"
              x2="408"
              y2="759"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#817E73" />
              <stop offset="1" stopColor="#C3BEAC" />
            </linearGradient>
            <clipPath id="clip0_2201_70">
              <path
                d="M415 344C415 345.105 414.105 346 413 346L410 346L410 246L413 246C414.105 246 415 246.895 415 248L415 344Z"
                fill="white"
              />
            </clipPath>
            <clipPath id="clip1_2201_70">
              <path
                d="M0 151C0 149.895 0.895431 149 2 149H5V180H2C0.89543 180 0 179.105 0 178V151Z"
                fill="white"
              />
            </clipPath>
            <clipPath id="clip2_2201_70">
              <path
                d="M0 211C0 209.895 0.895431 209 2 209H5V265H2C0.89543 265 0 264.105 0 263V211Z"
                fill="white"
              />
            </clipPath>
            <clipPath id="clip3_2201_70">
              <path
                d="M0 284C0 282.895 0.895431 282 2 282H5V338H2C0.89543 338 0 337.105 0 336V284Z"
                fill="white"
              />
            </clipPath>
            <clipPath id="clip4_2201_70">
              <rect x="3" width="409" height="843" rx="62" fill="white" />
            </clipPath>
            <clipPath id="clip5_2201_70">
              <rect x="7" y="4" width="401" height="835" rx="58" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
}
